import React from "react"
import styled from "styled-components"
import RedStar from "./redStar"

const Label = styled.label`
  text-align: left;
  max-width: 350px;
  margin: ${props => props.margin};
`

const Text = styled.p`
  margin: 0;
`

const LabelInput = ({content = "", margin = "", redStar = false, onChange = null, children}) => {
    return (
        <Label margin={margin} onChange={onChange}>
            <Text>
                {content}
                {children}
                {redStar ? <RedStar/> : null}
            </Text>
        </Label>
    )
}

export default LabelInput
